var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      {
        staticClass: "app-main-inner-tab",
        staticStyle: {
          "flex-grow": "1",
          display: "flex",
          "flex-direction": "column",
          height: "100%"
        }
      },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%", "flex-grow": "1", height: "100%" },
            attrs: { type: "card" },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            !_vm.isHM
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("Insurance.FreightInsuranceFirstPage"),
                      name: "cargoInsurance"
                    }
                  },
                  [_c("to-insure-page", { attrs: { "source-from": "page" } })],
                  1
                )
              : _vm._e(),
            _vm.checkPermission(["role_cargoInsurance_policyManagement"])
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      lazy: true,
                      label: _vm.$t("Insurance.PolicyManagement"),
                      name: "policyManagement"
                    }
                  },
                  [
                    _c("policy-grid", {
                      ref: "policyGrid",
                      attrs: { "insurance-type": 1 },
                      on: { changeTab: _vm.changeTab }
                    })
                  ],
                  1
                )
              : _vm._e(),
            !_vm.isHM &&
            _vm.checkPermission(["role_cargoInsurance_billingManagement"])
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      lazy: true,
                      label: _vm.$t("Insurance.BillingManagement"),
                      name: "billingManagement"
                    }
                  },
                  [
                    _c("agent-iframe", {
                      ref: "agentIframe",
                      attrs: { "jump-url": _vm.billUrl, type: "bill" }
                    })
                  ],
                  1
                )
              : _vm._e(),
            !_vm.isHM &&
            _vm.checkPermission(["role_cargoInsurance_invoiceManagement"])
              ? _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      lazy: true,
                      label: _vm.$t("CargoMsg.Cargo_InvoiceInformation"),
                      name: "invoiceInformation"
                    }
                  },
                  [
                    _c("agent-iframe", {
                      attrs: { "jump-url": _vm.invoiceUrl, type: "invoice" }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }